export class PatientConst {
  static readonly mode_basic: string = 'basic'; // 左邊清單維護模式，作為左邊清單的child元件
  static readonly mode_regList: string = 'regList'; // 來自櫃台掛號清單，back與save時要回掛號清單
  static readonly mode_opdList: string = 'opdList'; // 來自醫師門診清單，back與save時要回醫師門診清單
  static readonly mode_regReserve: string = 'regReserve'; // 來自預約掛號，back與save時要回預約掛號
  static readonly mode_firstVisit: string = 'firstVisit'; // 來自掛號的初診流程，back時回掛號清單，save成功進入新增掛號作業
  static readonly mode_phar: string = 'pharList'; // 來自藥局
}
